import { ICriteria, INonProductionDay } from "us.collection.admin/interfaces";

export enum NonProductionDayType {
    Non_SMS = "nonSms",
    Non_Printing = "nonPrinting",
    Non_Email = "nonEmail",
    Non_EHF = "nonEhf"
}

export enum YearNavigation {
    NEXT = "Next",
    PREVIOUS = "Previous"
}

export type NonProductionDayTypeInterface =
    NonProductionDayType.Non_Email |
    NonProductionDayType.Non_Printing |
    NonProductionDayType.Non_SMS |
    NonProductionDayType.Non_EHF

export enum NonProductionDayTypeTranslationKey {
    Non_EHF = "NON_EHF",
    Non_SMS = "NON_SMS",
    Non_Printing = "NON_PRINTING",
    Non_Email = "NON_EMAIL"
}

export type RedDay ={
    id: number;
    startDate: string;
    endDate: string;
    reason: string;
    nonEhf: boolean;
    nonSms: boolean;
    nonPrinting: boolean;
    nonEmail: boolean;
}

export type RedDayResponse ={
  id: number;
  startDate: string;
  endDate: string;
  reason: string;
  isFixedDate: boolean;
  isNonSMSDay: boolean;
  isNonPrintDay: boolean;
  isNonEmailDay: boolean;
  isNonEhfDay: boolean;
}

export type NonProductionDataType = {
    [key: string]: Array<RedDay>
};
